import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import logo from 'app/images/IQ-Transparent.png';
import { useMiaChatV2 } from 'app/context/MiaChatV2Context';
import { StyledContainer, ContentContainer, PromptsSection, SectionTitle } from './StyledComponents';
import { filterPromptsBySearch, transformOperationsToPrompts } from './utils';
import { OperationsPanelProps, PromptSelection } from './types';
import HeaderSection from './components/HeaderSection';
import SearchSection from './components/SearchSection';
import CategoryFilter from './components/CategoryFilter';
import PromptsGrid from './components/PromptsGrid';
import LoadingOverlay from './components/LoadingOverlay';
import LoadingState from './components/LoadingState';
import ErrorState from './components/ErrorState';

const OperationsPanel: React.FC<OperationsPanelProps> = ({
  onPromptSelect,
  loading = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTag, setSelectedTag] = useState('All');
  
  const { 
    operations, 
    loading: apiLoading, 
    error, 
    fetchOperations,
    getUniqueTags,
    getOperationsByTag
  } = useMiaChatV2();

  // Fetch operations when component mounts
  useEffect(() => {
    fetchOperations();
  }, []);

  // Get dynamic categories from operations tags
  const promptCategories = getUniqueTags();

  // Get filtered operations based on selected tag
  const tagOperations = getOperationsByTag(selectedTag);

  // Transform operations to prompts and apply search filter
  const transformedPrompts = transformOperationsToPrompts(tagOperations, selectedTag);
  // const filteredPrompts = filterPromptsBySearch(transformedPrompts, searchQuery);
  const filteredPrompts = transformedPrompts

  // Handle search submission
  const handleSearchSubmit = (query: string) => {
    onPromptSelect({title:query});
  };


  // Show loading state while API is loading
  if (apiLoading) {
    return (
      <StyledContainer>
        <ContentContainer>
          <LoadingState message="We're getting things ready for you..." />
        </ContentContainer>
      </StyledContainer>
    );
  }

  // Show error state if API fails
  if (error) {
    return (
      <StyledContainer>
        <ContentContainer>
          <ErrorState error={error} />
        </ContentContainer>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      <LoadingOverlay loading={loading} />
      
      <ContentContainer>
        <HeaderSection logo={logo} />

        <SearchSection
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          onSearchSubmit={handleSearchSubmit}
          loading={loading}
        />

        <PromptsSection>
          {/* <SectionTitle>
            {searchQuery ? `Search Results (${filteredPrompts.length})` : ''}
          </SectionTitle> */}

          {/* <CategoryFilter
            categories={promptCategories}
            selectedCategory={selectedTag}
            onCategorySelect={handleTagSelect}
            visible={!searchQuery}
          /> */}

          <PromptsGrid
            prompts={filteredPrompts}
            onPromptSelect={onPromptSelect}
            loading={loading}
          />
        </PromptsSection>
      </ContentContainer>
    </StyledContainer>
  );
};

export default OperationsPanel;
